import React from 'react';
import { useTranslation } from 'react-i18next';

const LANGUAGES = [
  { code: 'en', label: 'English' },
  { code: 'de', label: 'Deutsch' },
  { code: 'fr', label: 'Français' },
  { code: 'pl', label: 'Polski' },
  { code: 'ru', label: 'Русский' },
  { code: 'ro', label: 'Română' },
  { code: 'es', label: 'Español' },
];

export const LanguageSwitcher: React.FunctionComponent = () => {
  const { i18n } = useTranslation();

  const currentLang = (i18n.language || 'en').split('-')[0];

  return (
    <div className="navbar-item">
      <div className="select is-small">
        <select
          value={currentLang}
          onChange={(e) => i18n.changeLanguage(e.target.value)}
        >
          {LANGUAGES.map((lang) => (
            <option key={lang.code} value={lang.code}>
              {lang.label}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};
